// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swiper-button-next[data-v-2cd13940]:after,.swiper-button-prev[data-v-2cd13940]:after{content:none!important}", ""]);
// Exports
module.exports = exports;
